export enum Type {
  TOGGLE_MOBILE_DRAWER = 'TOGGLE_MOBILE_DRAWER',
}

export const toggleMobileDrawer = (status) => (dispatch) => {
  dispatch({ type: Type.TOGGLE_MOBILE_DRAWER, payload: status });
};
